import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class serviceDeliveryFormModel extends Model {

	// /**
	//  * Creates a new instance, called when using 'new'.
	//  *
	//  * @param  {Object}     [attributes]  Model attributes
	//  * @param  {Collection} [collection]  Collection that this model belongs to.
	//  * @param  {Object}     [options]     Options to set on the model.
	//  */
	// constructor(attributes = {}, collection = null, options = {}) {
	// 	super(attributes, collection, options);
	// 	this.init()
	// }
	//
	// init() {
	// 	Event.$on('testingTheEventListeners', (state) => {
	// 		console.log('triggered');
	// 		console.log(state);
	// 		console.log(this);
	// 	});
	// }

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'view',
			ref_num: '',
			file_name: '',
			data: {
				base64: '',
				token: localStorage.getItem('jwt'),
				type: '',
				ext: ''
			},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				view: 'GET',
				check: 'GET',
				save: 'POST',
				viewUploaded: 'GET'
			}
		}
	}

	routes() {
		return {
			view: 'job/{ref_num}',
			viewUploaded: 'job/',
			check: 'job/{ref_num}/check_slip?token=' + localStorage.getItem('jwt'),
			save: 'job/{ref_num}/slip/send'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	viewSDDetails() {
		this.methodTypes = 'view';
		return this.requestRoute();
	}

	checkSDPDetails() {
		this.methodTypes = 'check';
		return this.requestRoute();
	}

	saveFile() {
		this.methodTypes = 'save';
		return this.requestRoute();
	}

	getImage(ref_num) {
		this.ref_num = ref_num;
		this.methodTypes = 'viewUploaded';
		return this.requestRoute();
	}
}

// let test1 = new serviceDeliveryFormModel()
// let test2 = new serviceDeliveryFormModel()
// let test3 = new serviceDeliveryFormModel()
